import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
const darkGray = '#263238';
export const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginBottom: theme.spacing(2),
      boxShadow: 'none',
      border: '1px solid #A1AAE380 ',
      borderRadius: '10px!important',
      background: '#A1AAE312',
      overflow: 'hidden',
      minWidth: 280,
    },
    // Cofirm Dialog
    list: {
      listStyle: 'bullet',
      listStyleType: 'bullet',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      '& span': {
        fontSize: 25,
        paddingInlineEnd: theme.spacing(1),
      },
      '& li': {
        padding: 0,
        fontWeight: 'bold',
      },
    },
    listItems: {
      textAlign: 'right',
      padding: 0,
      marginBottom: 0,
      wordBreak: 'break-all',
    },
    // Key Header
    header: {
      border: 'none !important',
      minHeight: '95px !important',
      padding: theme.spacing(1),
      cursor: 'initial !important',
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
    },
    logo: {
      width: 60,
      height: 60,
      objectFit: 'contain',
      background: 'white',
      padding: theme.spacing(1),
      border: '1px solid #ccd1f0',
      borderRadius: 50,
      // marginBottom: -theme.spacing(0.6)
    },
    keyTitlePart: {
      marginInlineEnd: 'auto',
      marginInlineStart: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(2),
        marginInlineStart: theme.spacing(0.5),
      },
    },
    keyTitle: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'bold',
    },
    keyDesc: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'regular',
      marginTop: 8,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
    },
    clientPart: {
      marginInlineEnd: 'auto',
      marginInlineStart: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        marginInlineStart: theme.spacing(0.5),
      },
    },
    clientTitle: {
      fontSize: 14,
      color: darkGray,
      fontWeight: 'bold',
      '& span': {
        color: '#78909c',
        marginInlineStart: theme.spacing(1),
      },
    },
    clientDesc: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '400',
      fontFamily: 'Vazir',
      marginTop: 8,
      overflowWrap: 'break-word',
    },
    copyIcon: {
      width: 20,
      height: 20,
      color: '#78909c',
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
      position: 'relative',
      top: 5,
      '&:hover': {
        cursor: 'pointer',
      }
    },
    actions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginInlineEnd: 'auto',
        marginInlineStart: 'initial',
        marginTop: theme.spacing(2),
      },
    },
    expandBtn: {
      border: `1px solid #2b3990`,
      padding: theme.spacing(2),
      margin: 0,
      background: 'white',
      color: '#2b3990',
      '&:hover': {
        background: '#2b3990',
        color: '#fff',
        '& *': {
          stroke: '#fff'
        }
      }
    },
    actionsIcon: {
      color: '#7d8f9b',
      padding: theme.spacing(1),
      cursor: 'pointer',
      position: 'relative',
      top: 6,
    },
    // Key Details
    details: {
      borderTop: '1px solid #A1AAE380',
      background: '#fff',
      paddingTop: 0,
      paddingBottom: 0,
    },
    detailsContainer: {
      paddingInlineEnd: theme.spacing(2),
      paddingInlineStart: theme.spacing(0),
      width: 'calc(100% - 65px)',
      marginInlineStart: 'auto',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
      },
    },
    detailRow: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      borderBottom: `1px solid #A1AAE380`,
      '&:last-child': {
        border: 'none',
      },
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
      },
    },
    property: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '400',
    },
    disableClient: {
      color: colors.red.A700,
      fontWeight: 'bold',
    },
    propertyIcon: {
      fontSize: 25,
      color: '#d1d8dc',
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: '#508b46',
      },
    },
    supportNumber: {
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(2),
      },
    },
    partTitle: {
      fontSize: 14,
      color: darkGray,
      fontWeight: 'bold',
      '& span': {
        color: '#78909c',
        marginInlineStart: theme.spacing(1),
      },
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(2),
      },
    },
    showPassBtn: {
      color: '#2b3990',
      marginInlineStart: theme.spacing(-1),
      fontSize: 14,
      fontWeight: '400',
    },
    passText: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '300',
      fontFamily: 'Vazir',
      paddingTop: theme.spacing(0.8),
      paddingInlineStart: theme.spacing(1),
      letterSpacing: theme.spacing(0.2),
    },
    scopeItem: {
      display: 'inline-block',
      color: darkGray,
      fontSize: 14,
      fontFamily: 'Vazir',
      border: '1px solid #d0d4f1',
      background: '#f8f9fd',
      fontWeight: '400',
      padding: `${theme.spacing(0.7)} ${theme.spacing(1.6)} ${theme.spacing(
        0.4,
      )} ${theme.spacing(1.6)}`,
      lineHeight: 'initial',
      marginInlineEnd: 5,
      borderRadius: 6,
      marginBottom: 5,
      overflowWrap: 'break-word',
    },
    addressItem: {
      color: darkGray,
      fontSize: 14,
      fontFamily: 'Vazir',
      fontWeight: '300',
      lineHeight: 'initial',
      marginInlineEnd: 5,
      marginBottom: 5,
      overflowWrap: 'break-word',
    },
    partDetails: {
      [theme.breakpoints.down('lg')]: {
        width: '100%',
      },
    },
  };
});
